<section [ngClass.lt-sm]="{'layout xs':true}">
  <h2 fxLayout="row wrap" fxLayoutAlign="center center">
    <span>はじめての方へ</span>
  </h2>
  <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutAlign.xs="start center">
    <p>カイロプラクティックと聞くと、大多数の方が「ボキボキする治療でしょう？怖そうだね」というイメージを抱くようです。</p>
    <p>しかしこれは、テレビで創られた一つのイメージに過ぎません。</p>
    <p>カイロプラクティックが正しく理解されないために、我慢する必要の無い身体の苦しみを長い間抱えている方が、大勢いらっしゃいます。</p>
    <p>カイロプラクティックの安全性と有効性を理解してもらい、短期間で健康を取り戻していただきたいと当院では願います。</p>
  </div>
</section>
